module.exports = __webpack_public_path__ + "img/gomb-vizio.2160a1da.png";